import { render, staticRenderFns } from "./index.vue?vue&type=template&id=19ea08bd&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=19ea08bd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ea08bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19ea08bd')) {
      api.createRecord('19ea08bd', component.options)
    } else {
      api.reload('19ea08bd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=19ea08bd&scoped=true&", function () {
      api.rerender('19ea08bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/superAdmin/trustDecision/index.vue"
export default component.exports